import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ReactGA from "react-ga";
//import { google_key } from "../Data/data";
//import home_icon_top from "../Images/home-icon-top.png";
import menu_icon from "../Images/menu-icon.svg";
//import mediaplay from "../Images/mediaplay.svg";
//import dots from "../Images/dots.svg";
import Footer from "../Components/Footer";
import Menu from "../Components/Menu";
import { sendServicesDataApi } from "../Data/data";
import Get from "../Api/Get";
import Loader from "../Components/Loader";
import onestar from "../NewImages/1star.png";
import play from "../NewImages/play.png";
import InviteBanner from "../Images/pointsImg.png";
import pointslogo from "../Images/points.png";
import ellipseLogo from '../Images/Ellipse.png'


// import alllogo from "../NewImages/all-logo.png";
// import alllogo from "../Images/home-icon-top.png";
import alllogo from "../Images/mtn-logo.png";
// import remote from "../NewImages/remote.png";
import remote from "../NewImages/remo4.png";
//import newimg from "../NewImages/imagenew.png";
import "../Css/newcss.css";
import playlogo from '../Images/playlogo.png'
import Encode from "../EcodeRequest/Encode";
import Encodenew from "../EcodeRequest/Encodenew";

export const Homepage = () => {
  //To go on other page
  const navigate = useNavigate();

  //Hook to Store Games Data
  const [gamesData, setGamesData] = useState([]);

  //Calling for Games Data
  useEffect(() => {
    // checkColor();
    getGamesData();
    ReactGA.pageview(window.location.pathname);
    // eslint-disable-next-line
  }, []);

  //Getting Games Data
  const getGamesData = () => {
    let promise = Get(sendServicesDataApi);
    promise.then((e) => {
      handleResponse(e);
    });
  };

  //Handling Response of API
  const handleResponse = (e) => {
    if (e === "Network Error") {
      //Backend Not Working - so sending to error page
      navigate("/error");
    } else {
      setGamesData(e.response); //Setting games array to Hook
      setLoader("none"); //Hiding Loader
    }
  };

  //Hook to store loader div state
  const [loader, setLoader] = useState("block");

  //Hook to store color
  //const [color, setColor] = useState("");
  // const [colorTwo, setColorTwo] = useState("");

  //Method to Get Color according to serviceId
  // const checkColor = () => {
  //   // let serviceId = localStorage.getItem("serviceId");
  //   // if (serviceId === "11") {
  //   //   setColor("black");
  //   //   setColorTwo("#FFCC00");
  //   // } else if (serviceId === "1") {
  //   //   setColor("#00263a");
  //   //   setColorTwo("#5ec3e7");
  //   // } else {
  //   //   setColor("#00263a");
  //   //   setColorTwo("#5ec3e7");
  //   // }
  // };

  return (
    <>
      <Loader value={loader} />
      <Menu
        one="active"
        two="inactive"
        three="inactive"
        four="inactive"
        five="inactive"
        six="inactive"
      />
      <div className="container bg-color-yellow main-home">
        <div className="cus-header">
          <div className="col-md-6 col-xs-6">
            <div className="page-icon">
              <img src={alllogo} alt="allogo" />
              <Link to={"/homepage"}>Home</Link>
            </div>
          </div>
          <div className="col-md-6 col-xs-6">
            <span
              className="cus-menu navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#bs-example-navbar-collapse-1"
              aria-expanded="false"
            >
              <img alt="logo" src={menu_icon} />
              <span className="text-unselect cursor-pointer">menu</span>
            </span>
          </div>
        </div>
        {/* <div className="play-compete-c">
          <div className="play-inner-Win">Play Compete Win Big</div>
          <div className="play-logo">
            <img src={playlogo} alt="BigCash" />
          </div>
          <div className="play-inner-img-w" style={{display:'none'}}>
            <img src={remote} alt="remote"/>
          </div>
        </div> */}

        <div className="play-compete-c">
          <div className="play-inner-text">
            Play Complete Win Big
          </div>
          <div className="play-logo">
            <div className="logo-wrapper">
              <img src={ellipseLogo} alt="Ellipse" className="ellipse-img" />
              <img src={playlogo} alt="BigCash" className="play-img" />
            </div>
          </div>
        </div>



        <Link to="/refer" className="no-style-link"> {/* Optional class to remove link styles */}
          <div className="banner-image-container">
            <img src={InviteBanner} alt="Invite Banner" className="banner-image" />

            <div className="banner-content">
              <div className="text-content">
                <p className="txt-heading">Invite a Friend & Earn Rewards</p>
                <p>Earn points every time your referral code is used — redeem for airtime, cash & more.</p>
                <p className="cta-text">Share Your Code Now &gt;</p>
              </div>
              <img src={pointslogo} alt="Gift Icon" className="icon-image" />
            </div>
          </div>
        </Link>

        <div className="container-area">
          <div className="game-area">
            {gamesData &&
              gamesData.map((item, i) => {
                return (
                  <>
                    <div className="win-inner" key={i}>
                      <div className="win-inner-img">
                        <img src={item.imageUrl} alt="imageurl" />
                      </div>
                      <div className="custom-fix-image">
                        {/* <img src={newimg} /> */}
                      </div>
                      <div className="win-inner-c-r">
                        <h3>{item.game}</h3>
                        <p className="reating">
                          <span>
                            <img src={onestar} alt="onestar" />
                          </span>
                          <span>
                            <img src={onestar} alt="onestar" />
                          </span>
                          <span>
                            <img src={onestar} alt="onestar" />
                          </span>
                          <span>
                            <img src={onestar} alt="onestar" />
                          </span>
                          <span>
                            <img src={onestar} alt="onestar" />
                          </span>
                        </p>
                        <p>Earns Rewards and ...</p>
                      </div>
                      <div className="win-play-b">
                        {/* <Link to={item.gameUrl}>
                    <img src={play} />
                    
                  </Link> */}

                        <Link to={""}>
                          <img
                            src={play}
                            // onClick={() => {
                            //   let ani = localStorage.getItem("ani");
                            //   console.log(ani, "ani")
                            //   let gameId = item.gameid;
                            //   let serviceId = localStorage.getItem("serviceId");

                            //   const { encryptPayload } = Encode();
                            //   const encryptani = encryptPayload(ani)
                            //   console.log(encryptani, "=======")
                            //   // const encryptedAni = Encode(ani);
                            //   // const encrypt =encodeURIComponent(encryptedAni)
                            //   // console.log(encryptedAni, "===ani");

                            //   window.location.href = `${item.gameUrlLive}?ani=${encryptani}&gameId=${gameId}&serviceId=${serviceId}`;
                            // }}


// inside onClick
onClick={() => {
 let ani = localStorage.getItem("ani");
                               console.log(ani, "ani")
                             let gameId = item.gameid;
                              let serviceId = localStorage.getItem("serviceId");

  if (!ani || !serviceId || !gameId) {
    alert("Missing required parameters");
    return;
  }

  const { encryptPayload } = Encodenew();
  const encryptedAni = encryptPayload(ani); // 🔥 now this is a string

  window.location.href = `${item.gameUrlLive}?ani=${encryptedAni}&gameId=${gameId}&serviceId=${serviceId}`;
}}

                            alt="play"
                          />
                        </Link>
                      </div>
                    </div>
                  </>
                );
              })}
          </div>
          <div className="button-container" onClick={() => navigate('/refer')}>
            <p className="button-text">Invite A Friend</p>
          </div>
          <hr className="divider-line" />

          <Footer
            one="active"
            two="inactive"
            three="inactive"
            four="inactive"
          />
        </div>
      </div>
    </>
  );
};
